import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { admin, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="max-w-md mx-auto py-24 text-center text-stone-500">
        Loading…
      </div>
    );
  }
  if (admin) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(
        formatApiErrorDetail(err.response?.data?.detail) || "Login failed"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
      <div className="bg-white rounded-2xl border border-stone-200 p-8">
        <div className="w-12 h-12 rounded-xl bg-[#1E3A2B] text-[#DAA520] flex items-center justify-center mb-5">
          <Lock className="w-5 h-5" />
        </div>
        <h1
          className="font-display text-2xl font-bold text-stone-900"
          data-testid="admin-login-title"
        >
          Admin login
        </h1>
        <p className="text-stone-500 mt-1 text-sm">
          Access the moderation dashboard.
        </p>

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <label className="block">
            <div className="text-sm font-medium text-stone-700 mb-1.5">
              Email
            </div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-login-email"
              className="w-full bg-stone-50 border border-stone-200 rounded-lg px-3 py-2.5 focus:outline-none focus:border-[#C85A32]"
              placeholder="admin@bestschoolsabuja.ng"
            />
          </label>
          <label className="block">
            <div className="text-sm font-medium text-stone-700 mb-1.5">
              Password
            </div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
              className="w-full bg-stone-50 border border-stone-200 rounded-lg px-3 py-2.5 focus:outline-none focus:border-[#C85A32]"
            />
          </label>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full bg-[#C85A32] hover:bg-[#A84624] disabled:opacity-60 text-white font-semibold px-5 py-3 rounded-xl transition-colors"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
